import { makeStyles, Paper, Tab, Tabs } from '@material-ui/core'
import React, { useEffect } from 'react';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import UpdatePersonalDetail from './UpdatePersonalDetail';
import {useHistory} from 'react-router-dom'
import UpdateUserSkills from './UpdateUserSkills';
import { sleep } from './Models/CommonFunc';
import CheckUserProvider from '../AllHooks/CheckUserProvider';

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
});

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

function UserProfile() {
    const classes = useStyles();
    const [tabValue, setTabValue] = React.useState(0);
    const history = useHistory();
    const { userData } = CheckUserProvider();

    // useEffect(async () => {
    //     history.push('/user-profile');        
    // }, [userData]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <>
            <div className="container-fluid mt-3">
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <span style={{ fontWeight: '500', fontSize: '20px', marginBottom: '10px', color: '#0082ff', borderBottom: '1px solid #0082ff' }}>
                                    Update User Profile
                                </span>
                            </div>
                            <div className="col-md-6 offset-md-3 mt-3">
                                <Paper className={classes.root}>
                                    <Tabs
                                        value={tabValue}
                                        onChange={handleTabChange}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        centered>
                                        <Tab label="Update Personal Detail" style={{ padding: '10px', marginRight: '20px' }}
                                            icon={<AccountCircleIcon />} {...a11yProps(0)} />
                                        <Tab label="Update Skills & Other" icon={<ContactMailIcon />} {...a11yProps(1)} />
                                    </Tabs>
                                </Paper>
                            </div>
                            <div className="col-md-12 mt-3">
                                {
                                    tabValue === 0 ?
                                        <UpdatePersonalDetail />
                                        : <UpdateUserSkills />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserProfile
